import React from "react";
import Logger from "../../utils/Logger";

const Legend = ({
  items = [],
  title,
  selectedFilters = [],
  onFilterToggle,
  showOnlyMine = false,
  onToggleOnlyMine,
}) => {
  if (items.length === 0) {
    return null;
  }

  const handleItemClick = (item) => {
    if (onFilterToggle) {
      onFilterToggle(item);
    }
  };

  const handleToggleOnlyMine = () => {
    if (onToggleOnlyMine) {
      onToggleOnlyMine();
    }
  };

  return (
    <div style={{ marginTop: 16, marginBottom: 16, color: "white" }}>
      {title && (
        <div
          style={{
            marginBottom: 8,
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{title}</span>
          {onToggleOnlyMine && (
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                fontSize: "0.9em",
                padding: "4px 8px",
                borderRadius: "4px",
                border: showOnlyMine
                  ? "1px solid #ff9900"
                  : "1px solid transparent",
                backgroundColor: showOnlyMine
                  ? "rgba(255, 153, 0, 0.1)"
                  : "transparent",
                transition: "all 0.2s",
              }}
              onMouseOver={(e) => {
                if (!showOnlyMine) {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255, 255, 255, 0.05)";
                }
              }}
              onMouseOut={(e) => {
                if (!showOnlyMine) {
                  e.currentTarget.style.backgroundColor = "transparent";
                }
              }}
            >
              <input
                type="checkbox"
                checked={showOnlyMine}
                onChange={handleToggleOnlyMine}
                style={{
                  cursor: "pointer",
                  accentColor: "#ff9900",
                }}
              />
              <span style={{ color: showOnlyMine ? "#ff9900" : "inherit" }}>
                Tylko moje rezerwacje
              </span>
            </label>
          )}
        </div>
      )}
      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          marginTop: 8,
        }}
      >
        {items.map((item, index) => {
          const isSelected = selectedFilters.some(
            (filter) => filter.key === item.key || filter.label === item.label,
          );

          return (
            <div
              key={item.key || index}
              onClick={() => handleItemClick(item)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: onFilterToggle ? "pointer" : "default",
                padding: "4px 8px",
                borderRadius: "4px",
                backgroundColor: isSelected
                  ? "rgba(255, 153, 0, 0.2)"
                  : "transparent",
                border: isSelected
                  ? "1px solid #ff9900"
                  : "1px solid transparent",
                transition: "all 0.2s ease",
                opacity: isSelected ? 1 : selectedFilters.length > 0 ? 0.6 : 1,
              }}
              onMouseOver={(e) => {
                if (onFilterToggle) {
                  e.currentTarget.style.backgroundColor = isSelected
                    ? "rgba(255, 153, 0, 0.3)"
                    : "rgba(255, 255, 255, 0.1)";
                }
              }}
              onMouseOut={(e) => {
                if (onFilterToggle) {
                  e.currentTarget.style.backgroundColor = isSelected
                    ? "rgba(255, 153, 0, 0.2)"
                    : "transparent";
                }
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  background: item.color,
                  border: isSelected ? "2px solid #ff9900" : "1px solid #ccc",
                  boxShadow: isSelected
                    ? "0 0 4px rgba(255, 153, 0, 0.5)"
                    : "none",
                }}
                title={item.label}
              ></span>
              <span
                style={{
                  fontSize: "0.95em",
                  fontWeight: isSelected ? "600" : "normal",
                }}
              >
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Legend;
